export const ALABAMA_COUNTIES = [
  "Autauga", "Baldwin", "Barbour", "Bibb", "Blount", "Bullock", "Butler",
  "Calhoun", "Chambers", "Cherokee", "Chilton", "Choctaw", "Clarke", "Clay",
  "Cleburne", "Coffee", "Colbert", "Conecuh", "Coosa", "Covington", "Crenshaw",
  "Cullman", "Dale", "Dallas", "DeKalb", "Elmore", "Escambia", "Etowah",
  "Fayette", "Franklin", "Geneva", "Greene", "Hale", "Henry", "Houston",
  "Jackson", "Jefferson", "Lamar", "Lauderdale", "Lawrence", "Lee", "Limestone",
  "Lowndes", "Macon", "Madison", "Marengo", "Marion", "Marshall", "Mobile",
  "Monroe", "Montgomery", "Morgan", "Perry", "Pickens", "Pike", "Randolph",
  "Russell", "Shelby", "St. Clair", "Sumter", "Talladega", "Tallapoosa",
  "Tuscaloosa", "Walker", "Washington", "Wilcox", "Winston",
] as const;

export type AlabamaCounty = (typeof ALABAMA_COUNTIES)[number];

export const BUDGET_RANGES = [
  "Under $10K",
  "$10K – $50K",
  "$50K – $250K",
  "$250K – $1M",
  "$1M+",
] as const;

export const TIMELINES = [
  "< 3 months",
  "3 – 6 months",
  "6 – 12 months",
  "1 – 2 years",
  "Ongoing",
] as const;

export const STAGES = [
  "Concept",
  "Pilot",
  "Active program",
  "Scaling",
] as const;

export const FUNDING_SOURCES = [
  "Federal",
  "State",
  "Foundation",
  "Corporate",
  "Individual donors",
] as const;